<span mat-dialog-title class="title-medium on-surface-text">
  Subscribe in Outlook
</span>

<div mat-dialog-content class="dialog-content">
  <div class="steps-list">
    <div class="step-row">
      <div class="step-number">
        <span class="headline-small primary-text">1</span>
      </div>
      <div class="step-text">
        <span class="body-medium on-surface-text">
          Open the Calendars page in Outlook
        </span>
      </div>
    </div>

    <div class="step-row">
      <div class="step-number">
        <span class="headline-small primary-text">2</span>
      </div>
      <div class="step-text">
        <span class="body-medium on-surface-text">
          Click on "Add Calendar" and select "Subscribe from web"
        </span>
      </div>
    </div>

    <div class="step-row">
      <div class="step-number">
        <span class="headline-small primary-text">3</span>
      </div>
      <div class="step-text">
        <span class="body-medium on-surface-text">
          Paste the following URL into the field, and click "Import"
        </span>
      </div>
    </div>
  </div>

  <div class="url-container">
    <span class="on-surface-text url no-scrollbar">
      {{ $calendarUrl() }}
    </span>
    <button
      mat-icon-button
      matTooltip="Copy to clipboard"
      (click)="copyCalendarUrlToClipboard()"
    >
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-dialog-close mat-flat-button>Done</button>
</div>
